import createLucideIcon from '../createLucideIcon';

const BatteryFull = createLucideIcon('BatteryFullIcon', [
  [
    'rect',
    {
      x: '2',
      y: '7',
      width: '16',
      height: '10',
      rx: '2',
      ry: '2',
      key: '5j9scf',
    },
  ],
  ['line', { x1: '22', x2: '22', y1: '11', y2: '13', key: '4dh1rd' }],
  ['line', { x1: '6', x2: '6', y1: '11', y2: '13', key: '1wd6dw' }],
  ['line', { x1: '10', x2: '10', y1: '11', y2: '13', key: 'haxvl5' }],
  ['line', { x1: '14', x2: '14', y1: '11', y2: '13', key: 'c6fn6x' }],
]);

export default BatteryFull;
